<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Novo Atendimento") }}</h1>
    <form @submit.prevent="submit" ref="addItem">
      <!--Bloco Responsável Familiar-->
      <div class="row">
        <form-select
          v-model="atendimento.pessoas"
          :multiple="true"
          label="Usuário(s)"
          :itens="pessoas"
          :required="true"
        />
        <form-select
          v-model="atendimento.local"
          label="Local"
          grid="6"
          :itens="$root.arrays.atendimento_local"
          :required="true"
        />
        <form-select
          v-model="atendimento.tipo_id"
          label="Tipo"
          grid="6"
          :itens="tipos"
          btn-icon="mdi mdi-plus"
          :required="true"
          :loading="loading"
          :disabled="loading"
        />
        <form-select
          v-model="atendimento.outra_unidade_id"
          label="Outra Unidade"
          grid="12"
          :itens="outrasunidades"
          v-if="atendimento.local == 4"
        />
        <form-input
          v-if="atendimento.outra_unidade_id == 9999"
          v-model="atendimento.outra_unidade_nome"
          grid="12"
          label="Digite o nome da outra Unidade"
          :required="true"
        />
        <form-select
          v-if="verificarTipo(atendimento.tipo_id, 'DENÚNCIA')"
          v-model="atendimento.denuncia_id"
          label="Denúncia(s)"
          :multiple="true"
          :itens="denuncias"
          :loading="loading"
          :disabled="loading"
        />
        <form-select
          v-if="verificarTipo(atendimento.tipo_id, 'ABORDAGEM SOCIAL')"
          v-model="atendimento.situacao_abordagem_social"
          grid="12"
          label="Situação Identificada na Abordagem Social"
          :itens="$root.arrays.situacao_abordagem_social"
          :required="true"
          @change="verficaAbordagem"
          :multiple="true"
        />
        <form-select
          v-model="atendimento.tipo_servico_id"
          label="Serviço"
          grid="12"
          :itens="servicos"
          :loading="loading"
          :disabled="loading"
        />
        <form-input
          v-if="campoExtra"
          v-model="atendimento.outra_situacao_abordagem_social"
          grid="12"
          label="Digite a outra Situação Identificada na Abordagem Social"
          :required="true"
        />
        <form-calendar
          v-model="dataAdd"
          grid="4"
          label="Data do Atendimento"
          :required="true"
          ajuda="Data que o atendimento foi realizado"
          :max-date="dataNow"
        />
        <div 
          class="col-md-6"
            v-if="verificarTipo(atendimento.tipo_id, 'ESCUTA ESPECIALIZADA')"
        >
          <form-toggle
            label="A Ficha SINAN foi preenchida?"
            v-model="atendimento.ficha_sinan"
            ajuda="Caso o profissional opte pelo preenchimento, poderá acessá-la pelo portal SINAN federal. Link: https://portalsinan.saude.gov.br/images/documentos/Agravos/via/violencia_v5.pdf"
          />
          <div class="row">
            <div class="col-auto">Não</div>
            <div class="col-auto">Sim</div>
          </div>
        </div>
<!--        <form-calendar-->
<!--          v-model="atendimento.data_prevista"-->
<!--          grid="4"-->
<!--          label="Data do Agendamento"-->
<!--          :min-date="dataNow"-->
<!--        />-->
<!--        <form-calendar-->
<!--          v-model="atendimento.hora_prevista"-->
<!--          grid="4"-->
<!--          label="Hora do Agendamento"-->
<!--          mode="time"-->
<!--        />-->
        <form-textarea-editor
          v-model="atendimento.descricao_sumaria"
          grid="12"
          label="Descrição sumária do atendimento"
          :required="true"
        />
      </div>
      <search-tecnico :tecnicos.sync="atendimento.tecnicos" />
      <div class="row">
        <form-select
          v-model="atendimento.vulnerabilidades"
          label="Vulnerabilidades"
          :multiple="true"
          :itens="vulnerabilidades"
          :loading="loading"
          :disabled="loading"
        />
        <form-file
          @submit="submitFile"
          multiple
          btn-text="Iniciar"
          :progress="progressCompleted"
        />
      </div>
      <div class="row">
        <form-select
          v-model="atendimento.status"
          label="Status"
          grid="4"
          :itens="status"
          :loading="loading"
          :disabled="loading"
          :required="true"
        />
        <form-toggle
          grid="3"
          class="mt-4"
          v-model="atendimento.privado"
          label="Sigilo?"
        />
      </div>
      <div class="row pt-4 px-0 d-flex justify-content-end">
        <div class="col-auto px-2 text-right">
          <a class="btn btn-default" @click="$emit('voltar')">
            <i class="mdi mdi-arrow-left" />
          </a>
          <button
            class="btn btn-success btn-submit"
            data-style="zoom-in"
            type="submit"
          >
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  props: ["familia", "morph"],
  name: "Add",
  data() {
    return {
      atendimento: { tecnicos: [] },
      tecnicos: [],
      tecnicos_selected: null,
      tipos: [],
      servicos: [],
      denuncias: [],
      unidades: [],
      outrasunidades: [],
      status: [],
      files: [],
      vulnerabilidades: {},
      progressCompleted: 0,
      campoExtra: false,
      load_tipo: true,
      loading: true,
      unidade: "",
      tecnico_temp: "",
      loading_tecnicos: false,
      dataAdd: moment().format("YYYY-MM-DD"),
      showScheduling: false,
      atendimentoAgendamentos: {
        hora_prevista: "",
        data_prevista: "",
        descricao: "",
      },
    };
  },
  mounted() {
    this.getInformacaoCampos();
    // this.privateFromOsasco();
  },
  computed: {
    pessoas() {
      let pessoas = this.familia.familiares;
      pessoas = pessoas.filter((elem) => {
        return elem.estado_cadastral_cadunico <= 3;
      });
      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: elem.nome_social
          ? elem.nome_social + " <b>" + elem.idade + " ano(s)</b>"
          : elem.nome_completo + " <b>" + elem.idade + " ano(s)</b>",
      }));
      return map;
    },
    unidade_tecnicos() {
      this.loading_tecnicos = true;
      const pessoas = this.tecnicos;
      let tecnicos = [];
      pessoas.map((elem) => {
        if (elem.id_unidade == this.unidade) {
          tecnicos.push({
            id: elem.id,
            value: " <b>" + elem.value + "</b>",
          });
        }
      });
      setTimeout(() => {
        this.loading_tecnicos = false;
      }, 1000);
      this.tecnico_temp = null;
      return tecnicos;
    },
  },
  methods: {
    // privateFromOsasco() {
    //   const role_name = this.$store.state.user.role_details.name;
    //   if (
    //     window.location.hostname == "osascosp.suasfacil.com.br" ||
    //     window.location.hostname == "suasfacil.host" ||
    //     (window.location.hostname == "sandbox.suasfacil.com.br" &&
    //       role_name == "Técnico(a) de Nível Superior")
    //   ) {
    //     this.atendimento.privado = 1;
    //   } else {
    //     this.atendimento.privado = 2;
    //   }
    // },
    listTecnicosSelected() {
      if (this.atendimento.tecnicos.length > 0) {
        const pessoas = this.atendimento.tecnicos;
        let tecnicos = [];
        if (this.tecnicos) {
          pessoas.map((elem) => {
            let temp = this.tecnicos.find((item) => {
              return item.id == elem;
            });
            if (temp) {
              tecnicos.push({
                id: temp.id,
                value: " <b>" + temp.value + "</b> - " + temp.nome_unidade,
              });
            }
          });
        }
        this.tecnicos_selected = tecnicos.length > 0 ? tecnicos : null;
      } else {
        this.tecnicos_selected = null;
      }
      this.tecnico_temp = null;
    },
    setTecnicoParticipante() {
      if (this.atendimento.tecnicos == null) {
        this.atendimento.tecnicos = [this.tecnico_temp];
      } else {
        this.atendimento.tecnicos.push(this.tecnico_temp);
      }
      this.clearTecnicoTemp();
      this.listTecnicosSelected();
    },
    clearTecnicoTemp() {
      this.$refs.selecttecnico.item = null;
    },
    getInformacaoCampos() {
      this.loading = true;
      axios
        .get(`api/dashboard/atendimento/get/imformacao/campo`)
        .then((response) => {
          this.vulnerabilidades = response.data.vunerabilidades;
          this.tipos = response.data.tipos;
          this.denuncias = response.data.denuncias;
          this.servicos = response.data.servicos;
          this.tecnicos = response.data.tecnicos;
          this.unidades = response.data.unidades;
          this.outrasunidades = response.data.unidades;
          this.outrasunidades.push({
            id: 9999,
            value: "Outra",
          });
          this.status = response.data.status;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    verficaAbordagem(value) {
      value.indexOf(6) >= 0
        ? (this.campoExtra = true)
        : (this.campoExtra = false);
    },
    verificarTipo(tipo, search) {
      const result = this.tipos.filter(
        (item) => item.id == tipo && item.value == search
      );
      return result.length > 0 ? true : false;
    },
    submitFile(files) {
      this.files = files;
    },
    submit() {

      if (Array.isArray(this.atendimento.pessoas)) {
        this.atendimento.pessoas = this.atendimento.pessoas.filter(
          p => p && p.toString().trim() !== ""
        );
      }

      if (!this.atendimento.pessoas || this.atendimento.pessoas.length === 0) {
        this.$snack.success({
          button: false,
          text: "Selecione pelo menos um usuário válido!",
          color: "red",
        });
        return;
      }

      this.atendimento.familia_id = this.$route.query.familia_id;
      this.atendimento.morph = this.morph;
      if (this.dataAdd) {
        this.atendimento.data_cadastro = this.$options.filters.formatDateYMD(
          this.dataAdd
        );
      }
      let formData = new FormData();
      if (this.files.length > 0 && this.files.length != undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("anexos[]", this.files[i]);
        }
      } else {
        formData.append("anexos", this.files);
      }
      for (var key in this.atendimento) {
        if (key == "morph" && this.atendimento.morph != undefined) {
          formData.append(key, this.atendimento[key]);
          formData.append("morph_id", this.morph.id);
          formData.append("morph_type", this.morph.type);
        } else {
          formData.append(key, this.atendimento[key]);
        }
      }
      if (this.atendimento["situacao_abordagem_social"]) {
        for (const i of Object.keys(
          this.atendimento["situacao_abordagem_social"]
        )) {
          formData.append(
            "situacao_abordagem_social[]",
            this.atendimento["situacao_abordagem_social"][i]
          );
        }
      }
      if (this.showScheduling) {
        for (var key in this.atendimentoAgendamentos) {
          formData.append(
            "agendamento[" + key + "]",
            this.atendimentoAgendamentos[key]
          );
        }
      }

      if (
        formData.has("situacao_abordagem_social") &&
        !this.verificarTipo(this.atendimento.tipo_id, "ABORDAGEM SOCIAL")
      )
        formData.delete("situacao_abordagem_social");

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      axios
        .post(`api/dashboard/atendimentos`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          if (this.morph != undefined) {
            this.$emit("reload");
          } else {
            this.$router.push(
              `/dashboard/atendimentos/edit/${response.data.data.id}`
            );
          }
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
        });
    },
  },
};
</script>
